module.exports = __webpack_public_path__ + "img/btn.3a701908.png";